module.exports = "<div class=\"container-fluid\">\n    <div class=\"row\">\n        <button ui-sref=\"create\" class=\"btn btn-primary col-md-offset-6\">Create</button>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/dashboard/dashboard.html
// module id = 295
// module chunks = 0